import type { ApplicationCredential } from '../../../hooks/useApplicationCredentials';

export function filterCredentialsBySearch({
  credentials,
  query,
}: {
  credentials: ApplicationCredential[];
  query: string;
}): ApplicationCredential[] {
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) {
    return credentials;
  }

  return credentials.filter((credential) => {
    const name = (credential.name ?? '').toLowerCase();
    const username = credential.username.toLowerCase();
    const role = credential.role.toLowerCase();

    return (
      name.includes(normalizedQuery) ||
      username.includes(normalizedQuery) ||
      role.includes(normalizedQuery)
    );
  });
}

export function shouldShowCredentialsMenuSearch(
  credentialCount: number,
): boolean {
  return credentialCount > 2;
}

export function getCredentialDisplayName({
  credential,
  noUsernameLabel,
}: {
  credential: ApplicationCredential;
  noUsernameLabel: string;
}): string {
  if (credential.name) {
    return credential.name;
  }

  if (credential.username) {
    return credential.username;
  }

  return noUsernameLabel;
}
